








































































































import Vue from 'vue'
import moment from 'moment'

// import DateTimePicker1 from '@/components/date-time-picker/dt-picker1.vue'
import { FindActionHistory, FindStacks, Stack } from '@/api/cems'
export default Vue.extend({
  name: 'ActionLogComponent',
  data() {
    return {
      optsStatus: [
        { text: 'All', value: 'all' },
        { text: 'Active', value: 'active' },
        { text: 'Finish', value: 'finish' },
      ],
      optsParameters: [
        'Merkuri (Hg)',
        'Nitrogen Oksida (NOx)',
        'Partikulat (PM)',
        'Sulfur Dioksida (SO2)',
      ],
      stacks: [] as Stack[],
      loading: false,
      form: {
        parameters: [],
        actions: [],
        stacks: [],
        time: [],
        status: 'active',
      },
      actions: [] as any[],
      fields: [
        {
          key: 'StartTime',
          label: 'Start Date',
          thStyle: 'width:160px',
        },
        {
          key: 'EndTime',
          label: 'End Date',
          thStyle: 'width:160px',
        },
        {
          key: 'StackName',
          label: 'Chimney',
        },
        // {
        //   key: 'SispekStackCode',
        //   label: 'SISPEK Code',
        // },
        {
          key: 'UserName',
          label: 'User',
        },
        {
          key: 'Pending',
          tdClass: 'text-center',
          thStyle: 'width:160px',
        },
        {
          key: 'ParameterName',
          label: 'Parameter',
        },
        {
          key: 'SettingValue',
          tdClass: 'text-center',
          thStyle: 'width:160px',
        },
      ],
    }
  },
  methods: {
    async findStacks() {
      this.stacks = await FindStacks()
    },

    async findActionHistory() {
      let timeStart = 0
      let timeEnd = 0
      if (Array.isArray(this.form.time)) {
        if (this.form.time[0]) {
          timeStart = (this.form.time[0] as Date).valueOf()
        }
        if (this.form.time[1]) {
          timeEnd = (this.form.time[1] as Date).valueOf()
        }
      }
      this.actions = await FindActionHistory(
        this.form.stacks,
        this.form.parameters,
        this.form.actions,
        timeStart,
        timeEnd
      )
    },

    async onRefreshClick() {
      this.loading = true
      try {
        await this.findActionHistory()
      } catch {
        //
      }
      this.loading = false
    },

    formatTime(t: Date): string {
      return moment(t).format('YYYY-MM-DD HH:mm')
    },
  },

  created() {
    this.findStacks()
    this.findActionHistory()
  },
})
